import config from "@/app/config.js";

const currentVersion = config.VITE_APP_VERSION || null;

async function checkVersionAndRefresh(targetPath) {
  if (!currentVersion) return;

  try {
    const response = await fetch(`/version.json?_=${Date.now()}`);

    if (!response.ok) return;

    const { version } = await response.json();

    if (version && version !== currentVersion) {
      const safeTarget =
        typeof targetPath === "string" && targetPath.startsWith("/") && !targetPath.startsWith("//")
          ? targetPath
          : window.location.href;
      window.location.href = safeTarget;
    }
  } catch {
    // Silently ignore fetch errors (offline, network issues)
  }
}

// Auto-refresh when user returns to a stale tab
if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      void checkVersionAndRefresh();
    }
  });
}

export { checkVersionAndRefresh };
